// @flow

import { useCallback } from "react";

const useCurrentSrcChangeCallback = (
    setStyle: (
    (style: $Shape<CSSStyleDeclaration>) => $Shape<CSSStyleDeclaration>
  ) => void,
): ((newSource: string) => void) => useCallback(
    (newSource: string) => {
        setStyle((prevStyle: any) => ({
            ...prevStyle,
            backgroundImage: `url('${newSource}')`,
        }));
    },
    [setStyle],
);

export default useCurrentSrcChangeCallback;
